module.exports = __webpack_public_path__ + "static/media/stacked-xemelgo-light.392fe705.png";